import React from "react";

function resolveLink(sourceUrl, resourceBaseUrl) {
    if (!sourceUrl) return "";
    var url = sourceUrl.trim();
    if (url.indexOf("magento.fairfieldchair.com") !== -1 || url.indexOf("www.dropbox.com") !== -1) {
        // Extract filename from URL, strip query params
        var path = url.split("?")[0];
        var parts = path.split("/");
        var fileName = parts[parts.length - 1];
        if (fileName) return resourceBaseUrl + "/" + fileName;
    }
    return url;
}

function filterItems(items, resourceBaseUrl) {
    return items.filter(function (item) {
        if (!item.thumbnailImageName) return false;
        if (!item.sourceUrl) return false;
        var link = resolveLink(item.sourceUrl, resourceBaseUrl);
        return link !== "";
    });
}

export default class ResourcesPageComponent extends React.Component {
    constructor(props) {
        super(props);
        var categories = props.categories || [];
        this.state = {
            activeCategory: categories.length > 0 ? categories[0].name : "",
            openDropdown: null
        };
    }

    scrollToCategory = (catName) => {
        this.setState({ activeCategory: catName, openDropdown: null });
        var slug = catName.toLowerCase().replace(/[^a-z0-9]+/g, "-");
        var el = document.getElementById("resource-" + slug);
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    toggleDropdown = (catName) => {
        this.setState(function (prev) {
            return { openDropdown: prev.openDropdown === catName ? null : catName };
        });
    }

    formatDate = (dateStr) => {
        if (!dateStr) return "";
        try {
            var d = new Date(dateStr);
            return (d.getMonth() + 1).toString().padStart(2, "0") + "/" +
                d.getDate().toString().padStart(2, "0") + "/" +
                d.getFullYear();
        } catch (e) {
            return "";
        }
    }

    renderCard = (item, resourceBaseUrl) => {
        var thumbUrl = resourceBaseUrl + "/" + item.thumbnailImageName;
        var link = resolveLink(item.sourceUrl, resourceBaseUrl);
        var date = this.formatDate(item.documentUpdated);
        return (
            <div key={item.id} className="resources-card">
                <a href={link} target="_blank" className="resources-card-image">
                    <img src={thumbUrl} alt={item.name} />
                </a>
                <a href={link} target="_blank" className="resources-card-title">{item.name}</a>
                {date && <span className="resources-card-date">{date}</span>}
            </div>
        );
    }

    hasVisibleItems = (cat, resourceBaseUrl) => {
        if (!cat.subcategories) return false;
        return cat.subcategories.some(function (sub) {
            return filterItems(sub.items, resourceBaseUrl).length > 0;
        });
    }

    getVisibleSubcategories = (cat, resourceBaseUrl) => {
        if (!cat.subcategories) return [];
        return cat.subcategories.filter(function (sub) {
            return filterItems(sub.items, resourceBaseUrl).length > 0;
        });
    }

    render() {
        var self = this;
        var categories = this.props.categories || [];
        var resourceBaseUrl = this.props.resourceBaseUrl || "";

        // Filter to only categories with visible items
        var visibleCategories = categories.filter(function (cat) {
            return self.hasVisibleItems(cat, resourceBaseUrl);
        });

        return (
            <div className="resources-component">
                <div className="resources-tabs">
                    {visibleCategories.map(function (cat) {
                        var isActive = self.state.activeCategory === cat.name;
                        var visibleSubs = self.getVisibleSubcategories(cat, resourceBaseUrl);
                        var hasSubcategories = visibleSubs.length > 1;

                        if (hasSubcategories) {
                            return (
                                <div key={cat.name} className={"resources-tab-dropdown" + (isActive ? " active" : "")}>
                                    <button
                                        className="resources-tab"
                                        onClick={function () { self.toggleDropdown(cat.name); }}
                                    >
                                        {cat.name} <span className="resources-tab-arrow">{self.state.openDropdown === cat.name ? "\u25B2" : "\u25BC"}</span>
                                    </button>
                                    {self.state.openDropdown === cat.name && (
                                        <div className="resources-tab-menu">
                                            {visibleSubs.map(function (sub) {
                                                return (
                                                    <a
                                                        key={sub.name}
                                                        className="resources-tab-menu-item"
                                                        onClick={function () { self.scrollToCategory(cat.name + "---" + sub.name); }}
                                                    >
                                                        {sub.name}
                                                    </a>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            );
                        }

                        return (
                            <button
                                key={cat.name}
                                className={"resources-tab" + (isActive ? " active" : "")}
                                onClick={function () { self.scrollToCategory(cat.name); }}
                            >
                                {cat.name}
                            </button>
                        );
                    })}
                </div>

                {categories.map(function (cat) {
                    var hasSubcategories = cat.subcategories && cat.subcategories.length > 1;

                    if (hasSubcategories) {
                        return cat.subcategories.map(function (sub) {
                            var visibleItems = filterItems(sub.items, resourceBaseUrl);
                            if (visibleItems.length === 0) return null;
                            var sectionId = (cat.name + "---" + sub.name).toLowerCase().replace(/[^a-z0-9]+/g, "-");
                            var sectionTitle = cat.name + " \u2022 " + sub.name;
                            return (
                                <div key={sectionId} id={"resource-" + sectionId} className="resources-section">
                                    <h3 className="resources-section-title">{sectionTitle}</h3>
                                    <div className="resources-grid">
                                        {visibleItems.map(function (item) {
                                            return self.renderCard(item, resourceBaseUrl);
                                        })}
                                    </div>
                                </div>
                            );
                        });
                    }

                    var allItems = cat.subcategories && cat.subcategories.length === 1 ? cat.subcategories[0].items : [];
                    var visibleItems = filterItems(allItems, resourceBaseUrl);
                    if (visibleItems.length === 0) return null;
                    var slug = cat.name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
                    return (
                        <div key={cat.name} id={"resource-" + slug} className="resources-section">
                            <h3 className="resources-section-title">{cat.name}</h3>
                            <div className="resources-grid">
                                {visibleItems.map(function (item) {
                                    return self.renderCard(item, resourceBaseUrl);
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
